export const extractError = (error: any): string | undefined => `${error?.stack ?? error}`;
